var illuminant = require("./dist/illuminant"),
    workspace = require("./dist/workspace"),
    matrix = require("./dist/matrix"),
    degree = require("./dist/degree"),
    rgb = require("./dist/rgb"),
    xyz = require("./dist/xyz");

module.exports = {
	illuminant: illuminant,
	workspace: workspace,
	matrix: matrix,
	degree: degree,
	rgb: rgb,
	xyz: xyz
};
